import React, { useState } from 'react';
import { Box, Typography, Button, TextField, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export default function ImportUtilisateurs() {
  // State to track file selection
  const [selectedFile, setSelectedFile] = useState(null);

  // Handle file change
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  // Handle form submission (upload and import)
  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedFile) {
      console.log('File selected:', selectedFile);
      // Add logic to upload and import the file here
    } else {
      alert('Please select a file before uploading.');
    }
  };

  return (
    <>
      <Navbar />
      <Box p={3}>
        {/* Header */}
        <Box display="flex" alignItems="center">
          <PersonAddIcon />
          <Typography variant="h5" ml={1}> IMPORTER DES UTILISATEURS</Typography>
        </Box>

        {/* Form Section */}
        <Box mt={4}>
          <form onSubmit={handleSubmit}>
            {/* File Input */}
            <Box mb={2}>
              <Typography variant="body1">Excel File *</Typography>
              <TextField
                type="file"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
                fullWidth
                sx={{
                    mt: 1,
                    '& .MuiOutlinedInput-root': {
                      '&:hover fieldset': { borderColor: '#000' },
                      '&.Mui-focused fieldset': { borderColor: 'red' },
                    },
                    '& .MuiInputLabel-root': {
                      '&.Mui-focused': { color: 'red' },
                      '&:hover': { color: '#000' },
                    }
                  }}
              />
            </Box>

            {/* Upload Button */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                mt: 2,
                backgroundColor: '#000',
                color: '#fff',
                textTransform: 'none',
                width: '20%',
                '&:hover': {
                    backgroundColor: 'red',
                },
                }}
            >
              Uploader et Importer
            </Button>
          </form>
        </Box>

        {/* Description Section */}
        <Box mt={4}>
          <Typography variant="h6">Description du fichier</Typography>
          <ul style={{ listStyleType: 'disc', paddingInlineStart: '1rem', fontFamily: 'Roboto, sans-serif', fontSize: '16px', margin: 2 }}>
              <li>
                <strong>Site :</strong> Text
              </li>
              <li>
                <strong>Matricule :</strong> Text
              </li>
              <li>
                <strong>Nom :</strong> Text
              </li>
              <li>
                <strong>Prénom :</strong> Text
              </li>
              <li>
                <strong>Mot de passe :</strong> date de naissance
              </li>
            </ul>

          {/* Additional Instructions */}
          <Typography variant="body1" mt={2}>
            Les colonnes doivent respecter l'ordre suivant : Site, Nom, Prénom, Matricule, Mot de passe
          </Typography>
          <Typography variant="body1">
            Le matricule doit être unique
          </Typography>
        </Box>
      </Box>
    </>
  );
}